import React, { useState, useEffect } from 'react';

import { useParams, useHistory } from 'react-router-dom';

import { parseISO, addHours } from 'date-fns';

import { format } from 'date-fns-tz';

import { Document, Page, pdfjs } from 'react-pdf';
// import history from '~/services/history';

import { Exam } from '~/modules/pharmacist/pages';
import PrescriptionPage from '~/modules/patient/pages/prescription';
import {
  Container,
  HeaderContainer,
  Header,
  InfosHeader,
  TextHeader,
  BoxData,
  SpanData,
  BackgroundHeader,
  CardsContainer,
  FadeInContainer,
  PdfContainer,
  NotFoundReaderPdfButton,
} from './styles';

import { Modal, CodeValidator } from '~/shared/components';
import PrescriptionItem from './components/prescriptionItem';
import LoaderComponent from '~/shared/components/loader';
import api from '~/services/api';
import { LogoImage } from '~/shared/components/logoImage';
import validateHashOrigin from '~/utils';

function PatientHome() {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [numPages, setNumPages] = useState(null);
  const [prescriptionItems, setPrescriptionItems] = useState([
    {
      localId: 1,
      id: null,
      title: 'Receita Digital',
      show: false,
      icon: 'prescription',
    },
    {
      localId: 2,
      id: null,
      title: 'Atestado Médico',
      show: false,
      icon: 'sick_note',
    },
    {
      localId: 3,
      id: null,
      title: 'Solicitação de Exames',
      show: false,
      icon: 'exam',
    },
    {
      localId: 4,
      id: null,
      title: 'Relatório Médico',
      show: false,
      icon: 'report',
    },
    {
      localId: 5,
      id: null,
      title: 'Outros Documentos',
      show: false,
      icon: 'other_documents',
    },
  ]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setModalAsOpen] = useState(false);
  const [encounterDate, setEncounterDate] = useState(null);
  const [pdfOpen, setpdfOpen] = useState(false);
  const [pdfModalTitle, setPdfModalTitle] = useState('');
  const [docCount, setDocCount] = useState(0);
  const [pdfItems, setpdfItems] = useState('');
  const [pdfItemShowing, setpdfItemShowing] = useState('');
  const [validationKey, setValidationKey] = useState(null);
  const params = useParams();
  const history = useHistory();

  const onDocumentLoadSuccess = () => {
    setNumPages(numPages);
  };

  useEffect(() => {
    setLoading(true);
    api
      .get(`/document/${validateHashOrigin(params.id)}`)
      .then(({ data }) => {
        const { validation_key } = data;
        setValidationKey(validation_key);
        const prescriptionItemsVisible = [...prescriptionItems];
        const addedDate = addHours(parseISO(data.datetime), 3);
        const date = format(addedDate, "dd/MM/yyyy 'às' HH:mm", {
          timeZone: 'America/Sao_Paulo',
        });
        setEncounterDate(date);
        let counter = docCount;
        if (data.medication_prescription.contain) {
          counter += 1;
          prescriptionItemsVisible[0].show = true;

          prescriptionItemsVisible[0].id =
            data.medication_prescription.classification_id;
        }
        if (data.sick_note.contain) {
          counter += 1;
          prescriptionItemsVisible[1].show = true;
          prescriptionItemsVisible[1].id = data.sick_note.classification_id;
        }
        if (data.medical_exam.contain) {
          counter += 1;
          prescriptionItemsVisible[2].show = true;
          prescriptionItemsVisible[2].id = data.medical_exam.classification_id;
        }
        if (data.medical_report.contain) {
          counter += 1;
          prescriptionItemsVisible[3].show = true;
          prescriptionItemsVisible[3].id =
            data.medical_report.classification_id;
        }
        if (data.custom_document.contain) {
          counter += 1;
          prescriptionItemsVisible[4].show = true;
          prescriptionItemsVisible[4].id =
            data.custom_document.classification_id;
        }
        setPrescriptionItems(prescriptionItemsVisible);
        setDocCount(counter);
      })
      .catch((error) => {
        if (error) {
          history.push('/404');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [selectedItem]);

  const postDataAndOpenModal = async (value) => {
    return api
      .post(
        `/document/doctor/${validateHashOrigin(params.id)}/${selectedItem.id}`,
        {
          validation_key: value,
        }
      )
      .then((documentDoctorResponseData) => {
        const { accessToken } = documentDoctorResponseData.data;

        api
          .get(
            `/document/file/${validateHashOrigin(params.id)}/${
              selectedItem.id
            }`,
            {
              validation_key: value,
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          )
          .then(({ data: responseData }) => {
            setpdfItemShowing(responseData[0].url);
            setpdfItems(responseData);
            setpdfOpen(true);
            setModalAsOpen(false);
          });
      });
  };

  const handleItemClick = (item) => {
    setSelectedItem(item);
    if ([2, 4, 5].indexOf(item.localId) !== -1) {
      setModalAsOpen(true);
      setPdfModalTitle(item.title);
    }
  };

  const renderSelectedItem = () => {
    switch (selectedItem.localId) {
      case 1:
        return (
          <PrescriptionPage
            title={selectedItem.title}
            id={selectedItem.id}
            token={params.id}
            validationKey={validationKey}
            goBack={() => {
              setSelectedItem(null);
            }}
          />
        );
      case 3:
        return (
          <Exam
            title={selectedItem.title}
            id={selectedItem.id}
            token={params.id}
            validationKey={validationKey}
            selectedItem={() => {
              setSelectedItem(null);
            }}
          />
        );
      default:
        return <></>;
    }
  };

  const RenderedComponent =
    (selectedItem && selectedItem.localId === 3) ||
    (selectedItem && selectedItem.localId === 1) ? (
      <Container>{renderSelectedItem()}</Container>
    ) : (
      <FadeInContainer>
        {loading && <LoaderComponent />}
        <HeaderContainer>
          <BackgroundHeader BackgroundHeight="288px" />
          <Header>
            <LogoImage />
          </Header>
          <InfosHeader>
            <TextHeader>
              {docCount > 1
                ? 'Consulte os documentos gerados no seu atendimento'
                : 'Consulte o documento gerado no seu atendimento'}
            </TextHeader>
            <BoxData>
              <SpanData>DATA:</SpanData> {encounterDate}
            </BoxData>
          </InfosHeader>
        </HeaderContainer>
        <CardsContainer>
          {prescriptionItems.map((item, index) => {
            return item.show ? (
              <PrescriptionItem
                title={item.title}
                key={`${item.title}-${index + 1}`}
                icon={item.icon}
                onClick={() => handleItemClick(item)}
              />
            ) : null;
          })}
        </CardsContainer>
        {modalIsOpen && (
          <Modal
            widthContainer="350px"
            heightContainer="330px"
            isOpen={modalIsOpen}
            onCloseRequest={(event) => {
              event.preventDefault();
              setModalAsOpen(!modalIsOpen);
            }}
          >
            <CodeValidator
              width="165px"
              title="Desbloquear"
              fontSize="16px"
              height="50px"
              validationKey={validationKey}
              postData={(value) => postDataAndOpenModal(value)}
            />
          </Modal>
        )}
        {pdfOpen && (
          <Modal
            isPdfShowing="true"
            widthContainer="100%"
            headerSize="100vw"
            heightContainer="calc(100vh + 240px)"
            isOpen={pdfOpen}
            title={pdfModalTitle}
            onCloseRequest={(event) => {
              event.preventDefault();
              setpdfOpen(!pdfOpen);
            }}
            itens={pdfItems}
            onClickItens={(item) => {
              setpdfItemShowing(item.url);
            }}
          >
            <PdfContainer>
              <Document
                file={pdfItemShowing}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={<LoaderComponent />}
                height="auto"
                width="100vw"
                renderMode="canvas"
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
              </Document>

              <NotFoundReaderPdfButton>
                <a href={pdfItemShowing} target="_blank" rel="noreferrer">
                  Fazer o download
                </a>
              </NotFoundReaderPdfButton>
            </PdfContainer>
          </Modal>
        )}
      </FadeInContainer>
    );
  return RenderedComponent;
}

export default PatientHome;
